module.exports = {
    EMAIL_REGEX:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

    // Comprehensive regex to detect Markdown syntax
    MARKDOWN_REGEX: /(\*\*.*?\*\*|\*.*?\*|__.*?__|_.*?_|\#{1,6}\s.*|>.*|`{3}[\s\S]*?`{3}|`.*?`|!\[.*?\]\(.*?\)|\[.*?\]\(.*?\)|\*\s.*|\-\s.*|(\d+\.)\s.*|\-{3,})/g,
    // for url detect
    URL_REGEX: /(https?:\/\/[^\s]+)/g,
};
